import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsEBikeRideNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M20.084.374l-2.566 3.849a.5.5 0 00.416.777H20v2.349a.5.5 0 00.916.277l2.566-3.849A.5.5 0 0023.066 3H21V.65a.5.5 0 00-.916-.277zM13.15 6.474A1 1 0 0114 6h4v2h-2.382l2.085 4.17A5.006 5.006 0 0124 17a5 5 0 11-8.085-3.935l-.707-1.413-3.34 5.844A1 1 0 0111 18H9.9A5.002 5.002 0 010 17a5 5 0 016.297-4.83l.836-1.672-.001-.002.003-.002.247-.494H5V8h5v2h-.848l2.348 4.11 2.632-4.606.003.002-1.03-2.059a1 1 0 01.044-.973zM6.617 16h3.659l-1.952-3.415zm-1.247-1.977A3 3 0 107.83 18H5a1 1 0 01-.894-1.447zm11.47.894a3 3 0 101.789-.895l1.712 3.425-1.79.895z" />
      </g>
    </svg>
  )
);
SvgSportsEBikeRideNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsEBikeRideNormalSmall;
